import { DeviceSize } from '../state/constants';

export const desktopStyles = () => {
  return `@media (min-width: ${DeviceSize.desktop}px)`;
};
